// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"fc38a353","453":"1f2989a2","729":"42cd5aaf"}[chunkId] + ".chunk.js";
};